/**
 * Ajoute deux éléments cachés qui vont permettre de capturer le focus avant et après l'élément.
 * @param {HTMLElement} modalElement élément sur lequel le focus doit être enfermé.
 */
export function jailFocus(modalElement) {
  if (Object.hasOwn(modalElement, 'modalJailers')) {
    return;
  }
  const focusables = Array.from(modalElement.querySelectorAll(':scope *')).filter(isFocusable);
  const beforeJailer = createJailer();
  const afterJailer = createJailer();
  modalElement.insertBefore(beforeJailer, modalElement.firstChild);
  modalElement.appendChild(afterJailer);
  modalElement.modalJailers = {beforeJailer, afterJailer};
  if (focusables?.length > 0) {
    focusables[0].focus();
    afterJailer.addEventListener('focus', () => {
      focusables[0].focus();
    });
    beforeJailer.addEventListener('focus', () => {
      focusables[focusables.length - 1].focus();
    });
  }
}

/**
 * Suppression de la prison du focus.
 * @param {HTMLElement} modalElement élément sur lequel le focus doit être enfermé.
 */
export function unJailFocus(modalElement) {
  modalElement.modalJailers?.beforeJailer.remove();
  modalElement.modalJailers?.afterJailer.remove();
  delete modalElement.modalJailers;
}

function isFocusable(element) {
  if (element.getAttribute('tabindex') === '0') {
    return true;
  }
  if (element.classList.contains('js-focus-jailer')) {
    return false;
  }
  if (element.disabled) {
    return false;
  }
  switch (element.nodeName.toLowerCase()) {
    case 'a':
      return !!element.href && element.rel !== 'ignore';
    case 'input':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'button':
    case 'select':
    case 'textarea':
      return true;
    default:
      return false;
  }
}

/**
 * Créer un élément HTML permettant d'enfermer le focus.
 * @return {HTMLDivElement} élément qui va récupérer le focus.
 */
function createJailer() {
  const jailer = document.createElement('div');
  jailer.classList.add('visually-hidden', 'js-focus-jailer');
  jailer.setAttribute('tabindex', '0');
  return jailer;
}
